var acc = document.getElementsByClassName("accordion");
var accordion_index;
for (accordion_index = 0; accordion_index < acc.length; accordion_index++) {
  acc[accordion_index].addEventListener("click", function (e) {
    var panel = this.nextElementSibling;

    for (i = 0; i < acc.length; i++) {
      if(acc[i] != e.target ){  
        if(acc[i].nextElementSibling){
          acc[i].nextElementSibling.style.maxHeight = null;
          acc[i].classList.remove("active");
        }
      }
    }

    if (this.classList.contains("active") || this.closest('.accordion').classList.contains("active")) {
      panel.style.maxHeight = null;
      this.classList.remove("active");
      return;
    }

    this.classList.add("active");

    if (this.classList.contains("active")) {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } else if (!this.classList.contains("active")) {
      panel.style.maxHeight = null;
    }
  });
}

var acc_child = document.querySelectorAll(".child-accordions .accordion");
var accordion_child_index;

acc_child.forEach(el => {
  el.addEventListener('click', () => {
    el.closest('.panel').style.maxHeight = 'fit-content'
    el.closest('.panel').previousSibling.previousSibling.classList.add('active')
    setTimeout(()=>{
      el.closest('.panel').style.maxHeight = el.closest('.panel').offsetHeight + 'px'
    },400)
    
  })
})